import { render, staticRenderFns } from "./treeCatalog.vue?vue&type=template&id=436b5aeb&scoped=true"
import script from "./treeCatalog.js?vue&type=script&lang=js&external"
export * from "./treeCatalog.js?vue&type=script&lang=js&external"
import style0 from "./treeCatalog.vue?vue&type=style&index=0&id=436b5aeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b5aeb",
  null
  
)

export default component.exports